import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';
import classes from './style.module.scss';
import { ReactComponent as ClearSvg } from '../../../assets/icons/close.svg';

const Modal = ({
  open, onClose, children, className, zIndex,
}) => {
  const [showModal, modalShowToggle] = useState(false);

  useEffect(() => {
    setTimeout(() => modalShowToggle(open));

    if (open) {
      document.body.style.width = `${document.body.getBoundingClientRect().width}px`;
      document.body.style.overflowY = 'hidden';
      document.body.ontouchmove = () => false;
    } else {
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('width');
      document.body.ontouchmove = () => true;
    }
  }, [open]);

  const modalCls = [classes.modal_wrapper, className];

  if (showModal) modalCls.push(classes.show_modal);

  return (
    open && createPortal(
      <div
        id="modal"
        className={classes.modal_container}
        style={{ zIndex }}
      >
        <div
          className={classes.backdrop}
          onClick={onClose}
        />

        <div className={modalCls.join(' ')}>
          {onClose && (
            <ClearSvg
              className={classes.close}
              onClick={onClose}
            />
          )}

          {children}
        </div>
      </div>,
      document.getElementById('root') || document.body,
    )
  );
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  zIndex: PropTypes.number,
};

Modal.defaultProps = {
  className: '',
  zIndex: 30,
  onClose: null,
};

export default Modal;
